import { StringSchema } from 'yup';

export default function (this: StringSchema, message: string) {
  return this.test('chassis', message, function (value) {
    if (this.parent.renavam.toLowerCase() === value.toLowerCase())
      return this.createError({ message: 'Chassi do veículo não deve ser igual ao renavam.' });
    if (this.parent.plate.toLowerCase() === value.toLowerCase())
      return this.createError({ message: 'Chassi do veículo não deve ser igual a placa.' });
    return true;
  });
}
